export default {"src":"/_next/static/media/pause.aa6d71dd.svg","height":24,"width":24};